module.exports = __webpack_public_path__ + "img/awards_decoration2.8cccb06f.png";